import { render, staticRenderFns } from "./MarkingHeader.vue?vue&type=template&id=0a718cf2&scoped=true"
import script from "./MarkingHeader.vue?vue&type=script&lang=js"
export * from "./MarkingHeader.vue?vue&type=script&lang=js"
import style0 from "./MarkingHeader.vue?vue&type=style&index=0&id=0a718cf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a718cf2",
  null
  
)

export default component.exports